<div *ngIf="showFeedEndMessage" class="d-flex justify-content-center mt-3">
  <div class="text-center">
    <img
      src="assets/img/svg-icons/calendar-search.svg"
      alt="calendar-search"
      class="mb-3"
    />
    <h5 class="fw-semibold mb-2">{{ "common.caughtUp" | translate }}</h5>
    <p
      class="msg mb-4"
      [innerHTML]="
        'common.feedEndMessage' | translate: { dateRange: dateRange }
      "
    ></p>
    <button
      class="adjust-btn btn cursor-pointer py-2 px-4 rounded-2"
      (click)="onAdjust()"
    >
      {{ "common.adjustFilters" | translate }}
    </button>
  </div>
</div>
